import meta from '../data/tarot/meta.json'

export * from './tarotTopic'

/**
 * 타로 — 언어와 무관한 부분. 서버와 클라이언트가 같이 쓴다.
 * 장수는 여기에 적지 않는다. meta.json 의 카드 수가 기준이다 (CARD_COUNT).
 *
 * 카드 문장은 여기 없다.
 *  - 클라이언트는 src/i18n/tarotText.ts 로 고른 언어만 받는다.
 *  - 서버 프롬프트는 src/lib/tarotSource.ts 에서 한국어 원문을 쓴다.
 */

export const CARD_COUNT = meta.cards.length
export const TONE_RULES: string[] = meta.tone_rules

export const TAROT_FIELDS = [
  'summary',
  'daily',
  'advice',
  'love_single',
  'love_dating',
  'love_married',
  'work',
  'business',
  'study',
  'family',
  'self',
] as const
export type TarotField = (typeof TAROT_FIELDS)[number]

export type TarotSide = Record<TarotField, string>

/** 한 언어의 카드 문장. 키는 카드 id(문자열). */
export type TarotTextTable = Record<string, { name: string; upright: TarotSide; reversed: TarotSide }>

/**
 * 씨앗 문자열에서 만드는 난수. 씨앗이 같으면 **항상 같은 카드**가 나온다.
 * 같은 결과·같은 날이면 오늘의 타로가 같아야 하기 때문이다 ("다시 뽑기"는 씨앗이 달라져 예외).
 * 분포만 맞으면 되는 자리라 xorshift 로 충분하다.
 */
export function seededPicker(seed: string): (maxExclusive: number) => number {
  let state = 0x811c9dc5
  for (let i = 0; i < seed.length; i += 1) {
    state ^= seed.charCodeAt(i)
    state = Math.imul(state, 0x01000193) >>> 0
  }
  return (maxExclusive) => {
    state ^= state << 13
    state >>>= 0
    state ^= state >>> 17
    state ^= state << 5
    state >>>= 0
    return state % maxExclusive
  }
}
